<h4 class="modal-header">{{ config.title }}</h4>
<div class="modal-body">
    <div *ngIf="[REJECT_HINT_TYPES.STEP, REJECT_HINT_TYPES.CERTIFICATE].includes(type)">
        <label class="form-label form-label--bold">Comments:</label>
        <div class="note-item" *ngFor="let note of notes"><div class="note-text" [innerHTML]="note"></div></div>
    </div>
    <div *ngIf="type === REJECT_HINT_TYPES.AUDIT_PAUSE">
        <p>{{ config.organizationContactData.name }} has paused your credential due to the following reason:</p>
        <p class="note-text" *ngFor="let note of notes" [innerHTML]="note"></p>
        <p>
            Please contact {{ config.organizationContactData.name }} at {{ config.organizationContactData.email }} for
            further information.
        </p>
    </div>
    <div *ngIf="type === REJECT_HINT_TYPES.AUDIT_REJECT">
        <p>We have reviewed your submission and require further clarification, as per the notes below:</p>
        <p class="note-text" *ngFor="let note of notes" [innerHTML]="note"></p>
        <p>
            Compliance with {{ config.organizationContactData.name }} guidelines is a required part of the continuing
            education process. Remaining out of compliance may lead to the pausing or loss of your Board certification.
            To resolve this issue, please click the “{{ config.confirmButtonText }}” button below.
        </p>
    </div>
</div>
<div class="modal-footer">
    <button class="btn btn-default" (click)="onModalClose()">Close</button>
    <button *ngIf="config.confirmButtonText" class="btn btn-primary" (click)="onModalConfirm()">
        {{ config.confirmButtonText }}
    </button>
</div>
